import { useState } from 'react';
import { useTranslations } from 'next-intl';
import type { Comment } from '@core-api/comments/types/response';
import { Button } from '@mentimeter/ragnar-ui/button';
import { CommentsControlDataHandler } from './CommentsControlDataHandler';

export const ReplyDataHandler = ({
  comment,
  showReplyInput,
  onShowReplyChange,
  displayReplyButton,
  isOwner,
}: {
  comment: Comment;
  showReplyInput: boolean;
  onShowReplyChange: (arg: boolean) => void;
  displayReplyButton: boolean;
  isOwner: boolean;
}) => {
  const t = useTranslations('creation.comments');
  const [hideReplyButton, setHideReplyButton] = useState(false);
  const topLevelCommentId =
    comment.parentId === null ? comment.id : comment.parentId;

  if (!displayReplyButton || hideReplyButton) return null;

  if (showReplyInput)
    return (
      <CommentsControlDataHandler
        showControlButtonsInitially={true}
        onCancel={() => onShowReplyChange(false)}
        onSubmitComment={() => {
          onShowReplyChange(false);
          setHideReplyButton(true);
          setTimeout(() => setHideReplyButton(false), 1500);
        }}
        cta={t('comments_reply_add_reply_button')}
        placeholder={t('comments_reply_add_reply_placeholder')}
        parentCommentId={topLevelCommentId}
        isOwner={isOwner}
      />
    );

  return (
    <Button
      mt="space2"
      variant="secondary"
      size="compact"
      onClick={() => onShowReplyChange(true)}
    >
      {t('comments_reply_show_reply_button')}
    </Button>
  );
};
